// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Action_wrapper__D1Idv"};